function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOrderList, getOrderInfo, getOrderStatusNum as _getOrderStatusNum, getOrderStatistics, getOrderLog, orderMarkApi, updateTrackingNumberApi, exportOrderApi } from '@/api/supplier/order';
import orderSend from './orderSend';
import orderVideoSend from './orderVideoSend';
import { expressAllApi } from '@/api/sms';
var payTypes = [{
  value: 'weixin',
  label: '微信'
}, {
  value: 'yue',
  label: '余额支付'
}, {
  value: 'integral',
  label: '积分支付'
}, {
  value: 'offline',
  label: '授信支付'
}, {
  value: 'alipay',
  label: '支付宝'
}, {
  value: 'zeroPay',
  label: '零元付'
}, {
  value: 'joinpay',
  label: '汇聚支付'
}, {
  value: 'lepay',
  label: '乐刷支付'
}, {
  value: 'leshua',
  label: '乐刷'
}, {
  value: 'kuaipay',
  label: '快钱支付'
}, {
  value: 'joinBankPay',
  label: '汇聚快捷协议支付'
}, {
  value: 'else',
  label: '其他支付'
}];
export default {
  name: 'SupplierOrder',
  components: {
    orderSend: orderSend,
    orderVideoSend: orderVideoSend
  },
  data: function data() {
    return {
      payTypes: payTypes,
      tableFrom: {
        status: 'all',
        dateLimit: '',
        orderNo: '',
        deliveryId: '',
        page: 1,
        limit: 10,
        payType: '',
        merKeywords: ''
      },
      timeVal: [],
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      orderChartType: {},
      orderStatisticsData: [],
      summaryLoading: false,
      // 详情
      detailVisible: false,
      direction: 'rtl',
      detailLoading: false,
      orderDatalist: null,
      orderId: '',
      // 操作记录
      logDialogVisible: false,
      logLoading: false,
      logData: {
        list: [],
        total: 0
      },
      logFrom: {
        page: 1,
        limit: 10,
        orderNo: ''
      },
      // 发货
      expressListNormal: [],
      expressListElec: [],
      orderDetail: null,
      // 导出
      exportLoading: false
    };
  },
  filters: {
    payTypeFilter: function payTypeFilter(payType) {
      var map = {
        weixin: '微信',
        alipay: '支付宝',
        yue: '余额',
        joinpay: '汇聚支付',
        leshua: '乐刷',
        kuaipay: '快钱'
      };
      return map[payType] || payType || '-';
    }
  },
  mounted: function mounted() {
    this.getList();
    this.getOrderStatusNum();
    this.orderStatistics();
    this.getExpress();
  },
  methods: {
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      this.orderStatistics();
    },
    handleReset: function handleReset() {
      this.tableFrom = {
        status: 'all',
        dateLimit: '',
        orderNo: '',
        deliveryId: '',
        page: 1,
        limit: 10,
        payType: '',
        merKeywords: ''
      };
      this.timeVal = [];
      this.getList();
      this.getOrderStatusNum();
      this.orderStatistics();
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.seachList();
    },
    // 列表
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              _context.n = 2;
              return getOrderList(this.tableFrom);
            case 2:
              res = _context.v;
              this.tableData.data = res.list || [];
              this.tableData.total = res.total || 0;
            case 3:
              _context.p = 3;
              this.listLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 状态数量
    getOrderStatusNum: function () {
      var _getOrderStatusNum2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return _getOrderStatusNum({
                orderNo: this.tableFrom.orderNo,
                dateLimit: this.tableFrom.dateLimit,
                deliveryId: this.tableFrom.deliveryId,
                payType: this.tableFrom.payType
              });
            case 1:
              res = _context2.v;
              this.orderChartType = res;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getOrderStatusNum() {
        return _getOrderStatusNum2.apply(this, arguments);
      }
      return getOrderStatusNum;
    }(),
    // 统计
    orderStatistics: function () {
      var _orderStatistics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.summaryLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return getOrderStatistics({
                status: this.tableFrom.status,
                dateLimit: this.tableFrom.dateLimit,
                orderNo: this.tableFrom.orderNo,
                deliveryId: this.tableFrom.deliveryId,
                payType: this.tableFrom.payType
              });
            case 2:
              this.orderStatisticsData = _context3.v;
            case 3:
              _context3.p = 3;
              this.summaryLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function orderStatistics() {
        return _orderStatistics.apply(this, arguments);
      }
      return orderStatistics;
    }(),
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    statusText: function statusText(row) {
      if (!row.paid) return '未支付';
      if (row.refundStatus === 1 || row.refundStatus === 3) return '退款中';
      if (row.refundStatus === 2) return '已退款';
      var map = {
        0: '未发货',
        1: '待收货',
        2: '待评价',
        3: '已完成'
      };
      return map[row.status] || row.status;
    },
    // 详情
    onOrderDetails: function () {
      var _onOrderDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(orderId) {
        var _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.orderId = orderId;
              this.detailVisible = true;
              this.detailLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return getOrderInfo(orderId);
            case 2:
              this.orderDatalist = _context4.v;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              this.$message.error('获取详情失败');
            case 4:
              _context4.p = 4;
              this.detailLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function onOrderDetails(_x) {
        return _onOrderDetails.apply(this, arguments);
      }
      return onOrderDetails;
    }(),
    handleDetailClose: function handleDetailClose() {
      this.detailVisible = false;
      this.orderDatalist = null;
    },
    // 记录
    onOrderLog: function () {
      var _onOrderLog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(orderId) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.orderId = orderId;
              this.logFrom = {
                page: 1,
                limit: 10,
                orderNo: orderId
              };
              this.logDialogVisible = true;
              _context5.n = 1;
              return this.getOrderStatusList(orderId);
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onOrderLog(_x2) {
        return _onOrderLog.apply(this, arguments);
      }
      return onOrderLog;
    }(),
    getOrderStatusList: function () {
      var _getOrderStatusList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(orderId) {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              this.logLoading = true;
              _context6.p = 1;
              _context6.n = 2;
              return getOrderLog({
                orderNo: orderId,
                page: this.logFrom.page,
                limit: this.logFrom.limit
              });
            case 2:
              res = _context6.v;
              this.logData.list = res.list || [];
              this.logData.total = res.total || 0;
            case 3:
              _context6.p = 3;
              this.logLoading = false;
              return _context6.f(3);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[1,, 3, 4]]);
      }));
      function getOrderStatusList(_x3) {
        return _getOrderStatusList.apply(this, arguments);
      }
      return getOrderStatusList;
    }(),
    handleLogPageChange: function handleLogPageChange(page) {
      this.logFrom.page = page;
      this.getOrderStatusList(this.orderId);
    },
    handleLogSizeChange: function handleLogSizeChange(val) {
      this.logFrom.limit = val;
      this.getOrderStatusList(this.orderId);
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this = this;
      this.$prompt('订单备注', '备注', {
        inputType: 'textarea'
      }).then(function (_ref) {
        var value = _ref.value;
        orderMarkApi({
          orderNo: row.orderId,
          mark: value
        }).then(function () {
          _this.$message.success('操作成功');
          _this.getList();
        });
      }).catch(function () {});
    },
    // 获取快递公司
    getExpress: function () {
      var _getExpress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _t3, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return expressAllApi({
                type: 'normal'
              });
            case 1:
              this.expressListNormal = _context7.v;
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t3 = _context7.v;
            case 3:
              _context7.p = 3;
              _context7.n = 4;
              return expressAllApi({
                type: 'elec'
              });
            case 4:
              this.expressListElec = _context7.v;
              _context7.n = 6;
              break;
            case 5:
              _context7.p = 5;
              _t4 = _context7.v;
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this, [[3, 5], [0, 2]]);
      }));
      function getExpress() {
        return _getExpress.apply(this, arguments);
      }
      return getExpress;
    }(),
    // 发货
    sendOrder: function sendOrder(row) {
      this.orderId = row.orderId;
      this.orderDetail = null;
      this.$refs.send.modals = true;
    },
    // 修改运单号
    handleUpdateNumber: function () {
      var _handleUpdateNumber = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row) {
        var _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.orderId = row.orderId;
              _context8.p = 1;
              _context8.n = 2;
              return getOrderInfo(row.orderId);
            case 2:
              this.orderDetail = _context8.v;
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t5 = _context8.v;
              this.orderDetail = row;
            case 4:
              this.$refs.send.modals = true;
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function handleUpdateNumber(_x4) {
        return _handleUpdateNumber.apply(this, arguments);
      }
      return handleUpdateNumber;
    }(),
    // 导出
    exports: function () {
      var _exports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.exportLoading = true;
              _context9.p = 1;
              _context9.n = 2;
              return exportOrderApi({
                status: this.tableFrom.status,
                dateLimit: this.tableFrom.dateLimit,
                orderNo: this.tableFrom.orderNo,
                deliveryId: this.tableFrom.deliveryId,
                payType: this.tableFrom.payType,
                page: -1
              });
            case 2:
              res = _context9.v;
              if (res && res.fileName) {
                window.location.href = res.fileName;
              } else {
                this.$message.error('导出失败');
              }
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t6 = _context9.v;
              this.$message.error(_t6.message || '导出失败');
            case 4:
              _context9.p = 4;
              this.exportLoading = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3, 4, 5]]);
      }));
      function exports() {
        return _exports.apply(this, arguments);
      }
      return exports;
    }()
  }
};